import React from 'react';
import { RenderPage } from '@/src/render';
import styled from 'styled-components';
import { StockDetailsTab } from './sections/Tab/StockDetailsTab';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/src/store/configure';
import { updateExchangeAndCocode } from '@/src/store/reducers/stocks/stockDetailsSlice';

const Container = styled.div`
  width: 100%;
`;

export const StockDetails = () => {
  const exchange = document
    .getElementById('csr-stock-details-page')
    ?.getAttribute('data-exchange');
  const exchanges = document
    .getElementById('csr-stock-details-page')
    ?.getAttribute('data-exchanges');
  const cocode = document
    .getElementById('csr-stock-details-page')
    ?.getAttribute('data-cocode');

  store.dispatch(
    updateExchangeAndCocode({
      cocode,
      exchanges,
      exchange,
    }),
  );

  return (
    <Container>
      <StockDetailsTab />
    </Container>
  );
};

RenderPage(
  'csr-stock-details-page',
  <Provider store={store}>
    <BrowserRouter>
      <StockDetails />
    </BrowserRouter>
  </Provider>,
);
